import React, { useEffect, useState } from "react";
import TabManager from "../../tabManager";
import SearchField from "../../searchField";
import SaleTable from "../tables/AllTransaction-Tables/saleTable";
import PurchaseTable from "../tables/AllTransaction-Tables/purchaseTable";
import ExpenseTable from "../tables/AllTransaction-Tables/expenseTable";
import Header from "../header";
import Filter from "../../filter";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetSale } from "../../../redux/Transaction/action";
import { Dropdown } from "antd";
import PendingTable from "../tables/AllTransaction-Tables/pendingTable";

const AllTransaction = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("Sale");
  const [selectedId, setSelectedId] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [range, setRange] = useState([0, 0]);
  const [selectedStatus, setSelectedStatus] = useState();
  const [searchValue, setSearchValue] = useState(""); // State for search input
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
  });
  const [hasMoreData, setHasMoreData] = useState(true);

  const tabItems = [
    {
      title: "Sale",
      key: "Sale",
    },
    {
      title: "Purchase",
      key: "Purchase",
    },
    {
      title: "Expense",
      key: "Expense",
    },
    {
      title: "Pending",
      key: "Pending",
    },
  ];

  const handleFilterSubmit = () => {
    dispatch(
      GetSale({
        page: filters?.page,
        limit: filters?.limit,
        selectedId: selectedId,
        startDate: dateRange?.[0],
        endDate: dateRange?.[1],
        status: selectedStatus,
        minAmount: Number(range?.[0]),
        maxAmount: Number(range?.[1]),
        storeName: searchValue, // Add searchValue to the filter
      })
    ).then((res) => {
      if (res.data?.status === 401) {
        navigate("/");
      }
    });
  };

  const menu = (
    <Filter
      className={`w-[370px] 2xl:h-full h-[calc(100vh-220px)] max-h-[630px] overflow-y-scroll no-scrollbar`}
      handleFilterSubmit={handleFilterSubmit}
      selectedId={selectedId}
      setSelectedId={setSelectedId}
      dateRange={dateRange}
      setDateRange={setDateRange}
      setRange={setRange}
      range={range}
      selectedStatus={selectedStatus}
      setSelectedStatus={setSelectedStatus}
    />
  );

  useEffect(() => {
    if (activeTab === "Sale") {
      dispatch(
        GetSale({
          page: filters?.page,
          limit: filters?.limit,
          selectedId: selectedId,
          startDate: dateRange?.[0],
          endDate: dateRange?.[1],
          status: selectedStatus,
          minAmount: Number(range?.[0]),
          maxAmount: Number(range?.[1]),
          storeName: searchValue, // Add searchValue to the filter
        })
      )
        .then((res) => {
          if (res?.data?.status === 401) {
            navigate("/");
          }
          if (res?.data?.data?.length === 0) {
            setHasMoreData(false);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [dispatch, navigate, filters, searchValue, activeTab, selectedId, dateRange, range, selectedStatus]);

  useEffect(() => {
    // Reset searchValue when activeTab changes
    setSearchValue("");
  }, [activeTab]);

  return (
    <div className="w-full px-8 py-2 flex flex-col gap-[30px]">
      <Header title={"All Transactions"} />

      <div className="flex flex-col 2xl:flex-row gap-3">
        <div className="w-full">
          <TabManager
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabItems={tabItems}
          />
        </div>
        <div className="w-full flex items-center justify-end gap-5">
          {activeTab === "Sale" && (
            <Dropdown overlay={menu} trigger={["click"]} placement="bottomLeft">
              <button className="border bg-white h-[50px] w-[50px] rounded-[10px] flex items-center justify-center">
                <img src="/images/filterIcon.svg" alt="Filter" />
              </button>
            </Dropdown>
          )}
          <SearchField
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </div>
      </div>

      <div className="w-full">
        {activeTab === "Sale" && (
          <SaleTable
            filter={filters}
            hasMoreData={hasMoreData}
            setFilter={setFilters}
            setHasMoreData={setHasMoreData}
            searchValue={searchValue}
          />
        )}
        {activeTab === "Purchase" && (
          <PurchaseTable searchValue={searchValue} />
        )}
        {activeTab === "Expense" && <ExpenseTable searchValue={searchValue} />}
        {activeTab === "Pending" && <PendingTable searchValue={searchValue} />}
      </div>
    </div>
  );
};

export default AllTransaction;
